import { axiosInstance } from 'src/store/server/common/client';
import type { APICommonResponse } from 'src/types/common.types';

import type { getTermsRequest, getTermsResponse } from './terms.dto';

export const termsService = {
  // 약관 목록 조회 (terms_div 기준)
  getTerms: async ({ termsType }: getTermsRequest): Promise<APICommonResponse<getTermsResponse>> => {
    return axiosInstance.market.public.get('/about/terms/', {
      params: {
        terms_div: termsType,
      },
    });
  },
};
